import { Stack, Pagination } from "@mui/material";
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
import { getOperationsDomainsHttp, updateOperationsStatusHttp } from "../../../http/renewalHttp/RenewalHttp"; 

export default function GetOperationsDomains() {
    const [domainList, setDomainList] = useState([]);
    const [initialList, setInitialList] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    
    // State for Approve/Reject Modal
    const [actionModal, setActionModal] = useState({ open: false, type: '', item: null, comment: '' });

    const fetchOperationsData = useCallback(async () => {
        const response = await getOperationsDomainsHttp(); 
        if (response && response.domains) {
            setDomainList(response.domains);
            setInitialList(response.domains);
        } else {
            setDomainList([]);
            setInitialList([]);
        }
    }, []);

    useEffect(() => {
        fetchOperationsData();
    }, [fetchOperationsData]);

    const handleActionClick = (item, type) => {
        setActionModal({ open: true, type: type, item: item, comment: '' });
    };

    const submitStatusUpdate = async () => {
        const payload = {
            oad_id: actionModal.item.oad_id,
            status: actionModal.type, // 'APPROVED' or 'REJECTED'
            comment: actionModal.comment
        };

        const response = await updateOperationsStatusHttp(payload);
        if (response && !response.error) {
            alert(`Domain ${actionModal.type === 'APPROVED' ? 'Approved' : 'Rejected'} successfully`);
            setActionModal({ open: false, type: '', item: null, comment: '' });
            fetchOperationsData(); // Refresh the table
        } else {
            alert("Failed to update status");
        }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = domainList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(domainList.length / itemsPerPage);

    function handleSearch(event) {
        const item = event.target.value;
        const filtered = initialList.filter((d) => 
            d.domain_name.toLowerCase().includes(item.toLowerCase())
        );
        setDomainList(filtered);
        setSearch(item);
        setCurrentPage(1);
    }

    return (
        <>
            <PageTitle title="Operations Approval Domains" />
            
            {/* Modal Backdrop and Content */}
            {actionModal.open && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '400px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                        <h5 style={{ marginBottom: '15px' }}>{actionModal.type === 'APPROVED' ? '✅ Approve Domain' : '❌ Reject Domain'}</h5>
                        <p>Are you sure you want to {actionModal.type.toLowerCase()} <strong>{actionModal.item.domain_name}</strong>?</p>
                        
                        {actionModal.type === 'REJECTED' && (
                            <div className="mt-3">
                                <label><strong>Reason for Rejection:</strong></label>
                                <textarea 
                                    className="form-control" 
                                    rows="3" 
                                    placeholder="Enter reason..." 
                                    value={actionModal.comment}
                                    onChange={(e) => setActionModal({ ...actionModal, comment: e.target.value })}
                                />
                            </div>
                        )}

                        <div className="mt-4 d-flex justify-content-end" style={{ gap: '10px' }}>
                            <button className="btn btn-secondary btn-sm" onClick={() => setActionModal({ open: false, type: '', item: null, comment: '' })}>Close</button>
                            <button 
                                className={`btn btn-sm ${actionModal.type === 'APPROVED' ? 'btn-success' : 'btn-danger'}`}
                                onClick={submitStatusUpdate}
                                disabled={actionModal.type === 'REJECTED' && !actionModal.comment}
                            >
                                Confirm {actionModal.type === 'APPROVED' ? 'Approval' : 'Rejection'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Div className="col-md-12">
                <Div className="page-header-toolbar">
                    <Input 
                        type='text' 
                        placeholder="Search Domain..."
                        style={{ marginLeft: '50px', width: '300px' }} 
                        value={search}
                        onChange={handleSearch}
                    />
                </Div>
            </Div>

            <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                {domainList.length > 0 ? (
                    <Div style={{ overflowX: 'auto' }}>
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr style={{ fontSize: '14px', backgroundColor: '#f8f9fa' }}>
                                    <th>Domain Name</th>
                                    <th>SKU Name</th>
                                    <th>Seats</th>
                                    <th>TP Price</th>
                                    <th>Selling Price</th>
                                    <th>Term</th>
                                    <th>SRD</th>
                                    <th>GRD</th>
                                    <th style={{ width: '150px' }}>Action Status</th>
                                    <th>Sent By</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '13px' }}>
                                {currentItems.map((item) => (
                                    <tr key={item.oad_id}>
                                        <td style={{ fontWeight: 'bold' }}>{item.domain_name}</td>
                                        <td>{item.sku_name}</td>
                                        <td className="text-center">{item.number_of_seats}</td>
                                        <td>₹{item.tp_price}</td>
                                        <td style={{ fontWeight: 'bold' }}>₹{item.selling_price}</td>
                                        <td>{item.term}</td>
                                        <td>{item.srd_date}</td>
                                        <td>{item.grd_date}</td>
                                        <td className="text-center">
                                            {item.status === 'PENDING' ? (
                                                <Div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                                    <button className="btn btn-success btn-xs" style={{ fontSize: '10px' }} onClick={() => handleActionClick(item, 'APPROVED')}>Approve</button>
                                                    <button className="btn btn-danger btn-xs" style={{ fontSize: '10px' }} onClick={() => handleActionClick(item, 'REJECTED')}>Reject</button>
                                                </Div>
                                            ) : (
                                                <span className={`badge ${item.status === 'APPROVED' ? 'bg-success text-white' : 'bg-danger text-white'}`}>
                                                    {item.status}
                                                </span>
                                            )}
                                        </td>
                                        <td>{item.sent_by}</td>
                                        <td style={{ fontStyle: 'italic', color: '#666' }}>{item.operation_comments}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Div>
                ) : (
                    <p style={{ marginTop: '30px', textAlign: 'center' }}>No records found.</p>
                )}

                {domainList.length > 0 && (
                    <Stack spacing={2} className="mt-3 d-flex align-items-center">
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={(e, v) => setCurrentPage(v)} />
                    </Stack>
                )}
            </Div>
        </>
    );
}